export default "__VITE_ASSET__b4c7fbca__"